import { Injectable } from "@angular/core";

@Injectable({ providedIn: 'root' })
export class OptionsFormatterService {

    regExpr: string = "^([A-Za-z0-9]+)[ ]+([0-9]+)(C|P)([0-9]+)$";
    monthNames: string[] = ["Jan", "Feb", "Mar", "Apr", "May", "Jun","Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

    constructor() { }

    parseOptionSymbol(optionSymbol: string): OptionSymbol {
        let values: string[] = typeof optionSymbol === 'string' ? optionSymbol.match(this.regExpr) : null;
        if (values !== null) {
            let currentYear = String(new Date().getFullYear());
            let currentYearPrefix = currentYear.substr(0, currentYear.length - 2);
            let expirationDateYear = currentYearPrefix + parseInt(values[2].substr(0,2));
            return {
                underlyingSymbol: values[1],
                expirationDate: values[2],
                callOrPut: values[3],
                strikePrice: parseInt(values[4]) / 1000,
                expirationDateMonth: values[2].substr(2,2),
                expirationDateDay: values[2].substr(4,2),
                expirationDateYear: expirationDateYear
            } as OptionSymbol;
        } else {
            return null;
        }
    }

    printOptionSymbol(optionSymbol: string) {
        let symb = this.parseOptionSymbol(optionSymbol);

        if (symb != null) {
            let d = new Date(symb.expirationDateMonth + "/" + symb.expirationDateDay + "/" + symb.expirationDateYear);
            let dateString = this.formatShortMonth(d.getMonth()) + " " + d.getDate() + " " + d.getFullYear();
            return dateString + " " + (symb.callOrPut === "C" ? "Call" : "Put") + " " + symb.strikePrice;
        } else {
            return optionSymbol;
        }
    }

    getPutCallIndicator(optionSymbol: string) {
        let symb = this.parseOptionSymbol(optionSymbol);
        if (symb != null) {
            return symb.callOrPut === "C" ? "CALL" : "PUT";
        }
        return null;
    }

    formatShortMonth(monthIndex: number) {
        return this.monthNames[monthIndex];
    }

}

export interface OptionSymbol {
    underlyingSymbol: any;
    expirationDate: any;
    callOrPut: any;
    strikePrice: any;
    expirationDateMonth: any;
    expirationDateDay: any;
    expirationDateYear: any;
}